import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const latest = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 12);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              最近更新
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">最新更新的<strong>漫画章节</strong>，精彩不容错过</p>
          </div>
          <Link
            to="/category/rexue"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            全部作品
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {latest.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}